import { Flex } from '@library/uikit'
import React from 'react'
import styled from 'styled-components'
import { NotFoundItem } from '@library/uikit/src/components/Text/Text'

import { useTranslation } from '@library/localization'
import { ColumnCenter } from './Layout/Column'

interface ComingSoonProps {
  fullPage?: boolean
  children?: React.ReactNode
  showImage?: boolean
}

export const NotFoundImage = styled.div`
  background: url('/logo_new.svg');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  position: relative;
  width: 135px;
  height: 135px;

  & > img {
    border-radius: 50%;
  }
`

const ComingSoon: React.FC<ComingSoonProps> = ({ fullPage = true, showImage = true, children }) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" alignItems="center" p="24px" height={fullPage ? '100vh' : ''}>
      <ColumnCenter style={{ marginTop: showImage ? '91px' : '0px' }}>
        {showImage && <NotFoundImage />}
        {children && children}
        {!children && <NotFoundItem>{t('Coming Soon!')}</NotFoundItem>}
      </ColumnCenter>
    </Flex>
  )
}

export default ComingSoon
